module.exports = __webpack_public_path__ + "static/media/main.81716381.webp";